module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: 'Administrative Settings'
      }, {
        name: 'Form List',
        link: 'Form Builder Index'
      }, {
        name: 'Field Templates'
      }]
    }
  }), _vm._v(" "), (_vm.loading) ? _c('spinner') : _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Field Template")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    staticClass: "row",
    attrs: {
      "data-vv-scope": "field-template"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-input', {
    attrs: {
      "label": "Name",
      "name": "template-name",
      "validation-scope": "field-template",
      "validators": "required"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "label": "Description",
      "name": "template-description",
      "validation-scope": "field-template",
      "validators": "required"
    },
    model: {
      value: (_vm.template.description),
      callback: function($$v) {
        _vm.$set(_vm.template, "description", $$v)
      },
      expression: "template.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('editor-options-list', {
    attrs: {
      "values": _vm.template.options,
      "id": "template",
      "edit-value": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dcb90d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EditFieldTemplate.vue
// module id = 1711
// module chunks = 1